export const ACCEPTED_CURRENCIES_CHANGE = 'accepted_currencies_change';
export const ADD_BLANK_LINE_ITEM = 'add_blank_line_item';
export const ADD_CUSTOM_COLUMN = 'add_custom_column';
export const ADD_LOT = 'add_lot';
export const APPLY_BASELINE_CHANGES = 'apply_baseline_changes';
export const APPLY_CHANGES_TO_CUSTOM_COLUMN = 'apply_changes_to_custom_column';
export const COLLAPSE_LOT = 'collapse_lot';
export const CURRENCY_CHANGE = 'currency_change';
export const DELETE_LINE_ITEM = 'delete_line_item';
export const DELETE_LOT = 'delete_lot';
export const DISCARD_CHANGES = 'discard_changes';
export const FETCH_LINE_ITEMS = 'fetch_line_items';
export const FETCH_BASELINE_PRICES = 'fetch_baseline_prices';
export const FETCH_BASELINE_IN_PROGRESS = 'fetch_baseline_prices_in_progress';
export const FETCH_BASELINE_IN_PROGRESS_END = 'fetch_baseline_prices_progress_end';
export const FINISH_PROGRESS = 'finish_progress';
export const ERRORS_CHANGE = 'errors_change';
export const EVENT_CHANGES = 'event_changes';
export const EVENT_INCUMBENT_CHANGE = 'event_incumbent_change';
export const EVENT_SHELL_REFRESHED = 'event_shell_refreshed';
export const EXPAND_ALL = 'expand_all';
export const EXPAND_LOT = 'expand_lot';
export const LINE_ITEM_CHANGE = 'line_item_change';
export const LINE_ITEM_COLUMN_CHANGE = 'line_item_column_change';
export const LINE_ITEMS_IMPORT_CANCEL = 'line_items_import_cancel';
export const LINE_ITEMS_IMPORT_CONFIRM_ADD = 'line_item_import_confirm_add';
export const LINE_ITEMS_IMPORT_CONFIRM_REPLACE_ALL = 'line_items_import_confirm_replace_all';
export const LINE_ITEMS_IMPORT_ERROR = 'line_items_import_error';
export const LINE_ITEMS_IMPORT_SAVE_FINISHED = 'line_items_import_save_finished';
export const LINE_ITEMS_IMPORT_START = 'line_items_import_start';
export const LINE_ITEMS_IMPORT_SUCCESS = 'line_items_import_success';
export const LINE_ITEMS_UPLOAD = 'line_items_upload';
export const LINE_ITEMS_UPLOAD_CANCEL = 'line_items_upload_cancel';
export const LINE_ITEMS_UPLOAD_COLUMN_WARNING = 'line_items_upload_column_limit_warning';
export const LINE_ITEMS_UPLOAD_APPLY_COLUMN_LIMIT = 'line_items_upload_apply_column_limit';
export const LOT_CARD_HEADER_CHANGES = 'lot_card_header_changes';
export const LOT_PAGE_CHANGE = 'lot_page_change';
export const LOT_PAGE_LOADED = 'lot_page_loaded';
export const LOT_PAGE_VALIDATED = 'lot_page_validated';
export const REFRESH_VALIDATION = 'refresh_validation';
export const REFRESH_VALIDATION_DONE = 'refresh_validation_done';
export const RESET_BASELINE_STATE = 'reset_baseline_state';
export const REMOVE_COLUMN = 'remove_column';
export const SHOULD_REFRESH = 'should_refresh';
export const SYNC_ADDER_COLUMNS = 'sync_adder_columns';
export const SHOULD_RERENDER_LINE_ITEM_DATA = 'should_rerender_table';
export const START_FETCH = 'start_fetch';
export const START_PROGRESS = 'start_progress';
export const UPDATE_UI_CONFIG = 'update_ui_config';
export const UPDATE_ZERO_PRICED_LINE_ITEMS = 'update_zero_priced_line_items';
